"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignInWithEmail = void 0;
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const lib_pages_1 = __importDefault(require("@opsbase/lib-pages"));
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const useCallforward_1 = __importDefault(require("@opsbase/react-hooks/useCallforward"));
const Vertical_1 = __importDefault(require("@opsbase/web-layout/Vertical"));
const useNav_1 = __importDefault(require("@opsbase/web-nav/useNav"));
const TextFieldWithStateAndBlur_1 = __importDefault(require("@opsbase/web-textfield/TextFieldWithStateAndBlur/TextFieldWithStateAndBlur"));
const Button_1 = __importDefault(require("@opsbase/web-ui/Button"));
const Text_1 = __importDefault(require("@opsbase/web-ui/Text"));
const react_1 = __importStar(require("react"));
function SignInWithEmail() {
    const [email, setEmail] = (0, react_1.useState)(sessionStorage.getItem('email') || '');
    const { goTo } = (0, useNav_1.default)();
    const handleChangeEmail = (0, react_1.useCallback)(v => {
        sessionStorage.setItem('email', v);
        setEmail(v);
    }, []);
    const handleGoTo = (0, useCallforward_1.default)(url => () => goTo(url), [goTo]);
    const handleSubmit = (0, react_1.useCallback)(() => {
        goTo(lib_pages_1.default.AUTH_SIGNIN_ENTEROTP, undefined, { identifier: email });
    }, [email, goTo]);
    return (react_1.default.createElement(Vertical_1.default, { gutter: true, centered: true },
        react_1.default.createElement(Text_1.default, null, lib_i18n_1.default.t('welcome-setup-email')),
        react_1.default.createElement(TextFieldWithStateAndBlur_1.default, { autoComplete: 'username', label: lib_i18n_1.default.t('enter-email'), type: "email", value: email, fullWidth: true, onBlur: handleChangeEmail }),
        react_1.default.createElement(Button_1.default, { color: lib_palette_1.default.secondary, disabled: !email, fullWidth: true, onClick: handleSubmit, label: lib_i18n_1.default.t('sign-in-with-email') }),
        react_1.default.createElement(Text_1.default, null, "or"),
        react_1.default.createElement(Button_1.default, { color: lib_palette_1.default.positive, fullWidth: true, onClick: handleGoTo(lib_pages_1.default.AUTH_SIGNIN_PHONE), label: lib_i18n_1.default.t('sign-in-with-phone') }),
        react_1.default.createElement(Button_1.default, { color: lib_palette_1.default.positive, fullWidth: true, onClick: handleGoTo(lib_pages_1.default.AUTH_SIGNIN_TEAMBOARD), label: lib_i18n_1.default.t('sign-in-with-teamboard') })));
}
exports.SignInWithEmail = SignInWithEmail;
exports.default = SignInWithEmail;
